module.exports = __webpack_public_path__ + "static/media/choithramsSaveMoney.97325939.png";